import { Map } from 'immutable';
import * as ActionType from '../../actions/bironex';
import * as bironexConstants from '../../constants/bironexState';
var initialState = Map({
    fetching: false,
    error: undefined,
    createError: undefined,
    amount: undefined,
    result: undefined,
});
var updateBironexBlockFields = function (state, data) {
    if (data.attempts != null) {
        state = state.update('attempts', function () { return data.attempts; });
    }
    if (data.timeout != null) {
        state = state.update('timeout', function () { return data.timeout; });
    }
    if (data.max != null) {
        state = state.update('max', function () { return data.max; });
    }
    return state;
};
export default (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionType.FETCH_CREATE_RECHARGE_BIRONEX:
        case ActionType.FETCH_RECHARGE_BIRONEX:
            return state.update('fetching', function () { return true; });
        case ActionType.FAILURE_FETCH_RECHARGE_BIRONEX:
            state = state.update('fetching', function () { return false; });
            return state.update('error', function () { return bironexConstants.BIRONEX_ERROR; });
        case ActionType.FAILURE_FETCH_CREATE_RECHARGE_BIRONEX:
            state = state.update('fetching', function () { return false; });
            return state.update('createError', function () { return bironexConstants.BIRONEX_ERROR; });
        case ActionType.SUCCESS_FETCH_RECHARGE_BIRONEX:
            state = state.update('fetching', function () { return false; });
            state = updateBironexBlockFields(state, action.data);
            if (action.data.error) {
                state = state.update('error', function () { return action.data.error; });
            }
            else if (action.data.validationError) {
                state = state.update('error', function () { return action.data.validationError; });
            }
            else {
                state = state.update('error', function () { return undefined; });
                state = state.update('amount', function () { return action.data.amount; });
            }
            return state;
        case ActionType.SUCCESS_FETCH_CREATE_RECHARGE_BIRONEX:
            state = state.update('fetching', function () { return false; });
            var error_1 = action.data.error || action.data.Code;
            if (error_1) {
                state = state.update('error', function () { return error_1; });
            }
            else {
                state = state.update('result', function () { return 0; });
                state = state.update('amount', function () { return undefined; });
                state = state.update('error', function () { return undefined; });
            }
            return state;
        case ActionType.RESTORE_RECHARGE_BIRONEX_BLOCK:
            if (action.data && action.data.timeout > 0) {
                state = state.update('timeout', function () { return action.data.timeout; });
            }
            return state;
        case ActionType.CLEAR_RECHARGE_BIRONEX_BLOCK:
            return state.update('timeout', function () { return undefined; });
        case ActionType.INIT_RECHARGE_BIRONEX:
            return state
                .update('fetching', function () { return false; })
                .update('error', function () { return undefined; })
                .update('createError', function () { return undefined; })
                .update('amount', function () { return undefined; })
                .update('result', function () { return undefined; });
        default:
            return state;
    }
});



// WEBPACK FOOTER //
// ./src/reducers/recharge/bironexRechargeReducer.js